import { useQuery } from '@apollo/client';
import { 
    GET_ALL_ACCESS_HUB_AND_WAREHOUSES_FOR_ROLE,
    GetAllAccessHubAndWarehousesForRoleResponse
} from '../graphql/queries/getAllAccessHubAndWarehousesForRole';
import {
    GET_ALL_ACCESS_WAREHOUSES_FOR_ROLE,
    GetAllAccessWarehousesForRoleResponse
} from '../graphql/queries/getAllAccessWarehousesForRole';
import {
    GET_ALL_ACCESS_HUBS_FOR_ROLE,
    GetAllAccessHubsForRoleResponse
} from '../graphql/queries/getAllAccessHubsForRole';

/**
 * 获取所有角色可访问的hub和warehouse数据的Hook
 * 纯数据接口，不包含业务逻辑，需要手动控制查询
 */
export const useGetAllAccessHubAndWarehousesForRole = (options?: {
    skip?: boolean;
    fetchPolicy?: 'cache-first' | 'cache-only' | 'network-only' | 'no-cache' | 'standby';
}) => {
    const { skip = false, fetchPolicy = 'cache-first' } = options || {};
    
    const { data, loading, error, refetch } = useQuery<GetAllAccessHubAndWarehousesForRoleResponse>(
        GET_ALL_ACCESS_HUB_AND_WAREHOUSES_FOR_ROLE,
        {
            skip,
            fetchPolicy,
            errorPolicy: 'all',
            notifyOnNetworkStatusChange: false
        }
    );

    return {
        warehouses: data?.warehouses || [],
        loading,
        error,
        refetch
    };
};

/**
 * 获取所有角色可访问的warehouse数据的Hook
 * 纯数据接口，不包含业务逻辑，需要手动控制查询
 */
export const useGetAllAccessWarehousesForRole = (options?: {
    skip?: boolean;
    fetchPolicy?: 'cache-first' | 'cache-only' | 'network-only' | 'no-cache' | 'standby';
}) => {
    const { skip = false, fetchPolicy = 'cache-first' } = options || {};
    
    const { data, loading, error, refetch } = useQuery<GetAllAccessWarehousesForRoleResponse>(
        GET_ALL_ACCESS_WAREHOUSES_FOR_ROLE,
        {
            skip,
            fetchPolicy,
            errorPolicy: 'all',
            notifyOnNetworkStatusChange: false
        }
    );

    return {
        warehouses: data?.warehouses || [],
        loading,
        error,
        refetch
    };
};

/**
 * 获取所有角色可访问的hub数据的Hook
 * 纯数据接口，不包含业务逻辑，需要手动控制查询
 */
export const useGetAllAccessHubsForRole = (options?: {
    skip?: boolean;
    fetchPolicy?: 'cache-first' | 'cache-only' | 'network-only' | 'no-cache' | 'standby';
}) => {
    const { skip = false, fetchPolicy = 'cache-first' } = options || {};
    
    const { data, loading, error, refetch } = useQuery<GetAllAccessHubsForRoleResponse>(
        GET_ALL_ACCESS_HUBS_FOR_ROLE,
        {
            skip,
            fetchPolicy,
            errorPolicy: 'all',
            notifyOnNetworkStatusChange: false
        }
    );

    return {
        warehouses: data?.warehouses || [],
        loading,
        error,
        refetch
    };
};